const T_PREFIX = "my-inquiries";

export const myInquiriesTrns = {
  title: `${T_PREFIX}.title`,
};

export const noMyInquiriesBannerTrns = {
  title: `${T_PREFIX}.no-my-inquiries-banner.title`,
  description: `${T_PREFIX}.no-my-inquiries-banner.description`,
  addInquiryButton: `${T_PREFIX}.no-my-inquiries-banner.add-inquiry-btn`,
};
